import { render, staticRenderFns } from "./p23.vue?vue&type=template&id=1998adc7&scoped=true&"
import script from "./p23.vue?vue&type=script&lang=js&"
export * from "./p23.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998adc7",
  null
  
)

export default component.exports